import dynamic from 'next/dynamic'
import { CartButton } from './CartButton'

// Removing hydration error on development mode
export const CartButtonDynamic =
  process.env.NODE_ENV === 'production'
    ? CartButton
    : dynamic(() => import('./CartButton').then((m) => m.CartButton))
